import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 7.3: het HR-besluit (goedkeuren/afwijzen met reden). Naar het model
 * van `useDecideLeaveRequest`, maar met een eigen pad — het is een ander
 * besluit op een andere as (AD-29).
 *
 * Drie lijsten worden ververst, want dit besluit is de LAATSTE benodigde
 * goedkeuring: de goedkeuringslijst (de rij verdwijnt of verandert van
 * status), het eigen verlofoverzicht van de aanvrager, en de
 * aanwezigheidskalender — een afwijzing haalt de afwezigheid daar weg
 * (FR-15).
 */
export function useDecideHrStap() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      decision,
      reason,
    }: {
      id: number;
      decision: 'approve' | 'reject';
      reason?: string;
    }) => verlofApi.hrDecide(id, decision, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
